export default __webpack_public_path__ + "static/media/landranger.0b120dfd.jpg";